import { Stack, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";

type Props = {
	children: ReactNode;
};

export const FlatRowGroup: FC<Props> = ({ children }) => {
	const theme = useTheme();

	return (
		<Stack
			bgcolor={theme.palette.background.paper}
			borderTop={1}
			borderBottom={1}
			borderColor="surface.border"
		>
			{children}
		</Stack>
	);
};
